import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => {
  return {
    root: {
      width: '100%',
      marginTop: theme.spacing(2.125),
    },
    responsiveLineWrapper: {
      display: 'flex',
      height: theme.spacing(26),
    },
    legendsWrapper: {
      marginTop: theme.spacing(2.125),
    },
    tooltip: {
      background: theme.palette.labraText.tertiary,
      color: theme.palette.text.white,
      width: 'fit-content',
      padding: theme.spacing(0.4, 1),
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      minHeight: '24px',
      borderRadius: theme.spacing(0.4),
    },
    imgIcon: {
      height: '20px',
      width: '20px',
      background: theme.palette.text.white,
      borderRadius: theme.spacing(0.4),
      padding: theme.spacing(0.25),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }
})

export const themeForRevenueLineGraph = (
  color: string,
  customColor?: string
) => ({
  axis: {
    ticks: {
      text: {
        fill: customColor ? customColor : color,
        fontSize: 11,
        fontWeight: customColor ? 500 : 400,
        fontFamily: 'Poppins',
      },
    },
    legend: {
      text: {
        fill: color,
        fontSize: 11,
        fontWeight: 400,
        fontFamily: 'Poppins',
      },
    },
  },
  grid: {
    line: {
      fill: '#F1F1F1',
    },
  },
})
